"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = require("../Icon");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var IconSymbols_1 = require("../../generated/IconSymbols");
var enums_1 = require("../../enums");
var hasEvent = function (evt) {
    return evt !== null && evt !== undefined;
};
var Tag = function (props) {
    var isEditable = props.isEditable, onClick = props.onClick, tagText = props.tagText, testId = props.testId, isNew = props.isNew;
    var cls = (0, BootstrapHelper_1.B)()
        .bl("tag")
        .pmod("tag-".concat((isEditable ? "edit" : "view")))
        .pmod("".concat(hasEvent(onClick) ? "has-event" : "")).bem;
    var newText = isNew ? " (new)" : "";
    var tagTextPrefix = isEditable ? "Label".concat(newText, ": ") : "";
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls, " ").concat(props.className || ""), style: props.style, "data-testid": testId }, { children: [!props.isEditable && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "icon", symbol: IconSymbols_1.IconSymbols.TagFilled, size: enums_1.UiSizes.SM, onClick: onClick })), tagTextPrefix + tagText, props.isEditable && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "icon icon--close", symbol: IconSymbols_1.IconSymbols.Close, size: enums_1.UiSizes.SM, onClick: onClick }))] })));
};
exports.Tag = Tag;
